import { USER_PROFILE_ID,MANAGER_TAB,ADMIN_TASK_TAB,PAGINATION,COMPANY_MASTER_TAB, ADVICE_LOG_BOOK,SENT_FOR_REVIEW_TAB, SYSTEMATIC_PLAN_TAB, ADMIN_INVOICE_TAB, ADMIN_ASSIGN_TASK_TAB, ADMIN_MY_TASK_TAB, USER_LOGIN_FAIL, USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGOUT, SHARE_TAB, REPORT_TYPE, SLAB_TAB, AGREEMENT_TAB } from "../actions/CommonAction";

export interface UserState {
    loading?: boolean,
    error?: string,
    loginSuccess?: false,
    userInfo: {}
}

interface Action {
    type: string,
    payload?: object
}

export const userLoginReducer = (state: UserState = { userInfo: {} }, action: Action) => {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return { loading: true }
        case USER_LOGIN_SUCCESS:
            return { loading: false, userInfo: action.payload, loginSuccess: true }
        case USER_LOGIN_FAIL:
            return { loading: false, error: action.payload, loginSuccess: false }
        case USER_LOGOUT:
            return {}
        default:
            return state
    }
};

export interface systematicPlanTabState {
    tabName: any;
}

export const getSystematicPlanTab = (
    state: systematicPlanTabState = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case SYSTEMATIC_PLAN_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface adminInvoiceTabState {
    tabName: any;
}
export interface slabTypeTabState {
    tabName: any;
}
export const getAdminInvoiceTab = (
    state: adminInvoiceTabState = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case ADMIN_INVOICE_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};
export const getslabTypeTab = (
    state: slabTypeTabState = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case SLAB_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface adminAssignTaskTabState {
    tabName: any;
}

export const getAdminAssignTaskTab = (
    state: adminAssignTaskTabState = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case ADMIN_ASSIGN_TASK_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};
export interface adminMyTaskTabState {
    tabName: any;
}

export const getAdminMyTaskTaskTab = (
    state: adminMyTaskTabState = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case ADMIN_MY_TASK_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface userProfileId {
    tabName: any;
}

export const getUserProfileId = (
    state: userProfileId = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case USER_PROFILE_ID:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface adviceLogBook {
    tabName: any;
}

export const getAdviceLogBook = (
    state: adviceLogBook = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case ADVICE_LOG_BOOK:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface shareTab {
    tabName: any;
}

export const getShareTab = (
    state: shareTab = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case SHARE_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};
export interface sentForReviewTab {
    tabName: any;
}

export const getSentForReviewTab = (
    state: sentForReviewTab = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case SENT_FOR_REVIEW_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface sentManagerTab {
    tabName: any;
}

export const getManagerTab = (
    state: sentManagerTab = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case MANAGER_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface sentCompanyMasterTab {
    tabName: any;
}

export const getCompanyMasterTab = (
    state: sentCompanyMasterTab = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case COMPANY_MASTER_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};
export interface setPagination {
    tabName: any;
}

export const getPagination = (
    state: setPagination = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case PAGINATION:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface setAdminTaskTab {
    tabName: any;
}

export const getAdminTaskTab = (
    state: setAdminTaskTab = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case ADMIN_TASK_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface setData {
}

export interface setAdminAgreementTab {
    tabName: any;
}

export const getAdminAgreementTab = (
    state: setAdminAgreementTab = { tabName: null },
    action: Action
) => {
    switch (action.type) {
        case AGREEMENT_TAB:
            return { tabName: action.payload };
        default:
            return state;
    }
};

export interface setData {
}


export const getData = (
    state: any = { },
    action: Action
) => {
    switch (action.type) {
        case REPORT_TYPE:
            return action.payload;
        default:
            return state;
    }
};

